export default function generateRandomNickname() {
  return "cabiner" + Math.floor(Math.random() * 100).toString()
}



// WEBPACK FOOTER //
// ./src/utils/nickname.js